import React, { useState } from 'react';
import { WppTypography } from '@wppopen/components-library-react';
import { capitalizeFirstLetter, IPlotlyContainer, TestIds } from 'utils';
import { useScreenshot } from 'hooks';
import { PlotlyFromApi } from './PlotlyFromApi/PlotlyFromApi';
import { SidePanel } from './SidePanel/SidePanel';
import { projectionSlice } from 'Redux/projectionsSlice';
import { useSelector } from 'react-redux';
import {
    Main,
    MainWrapper,
    MainHeader,
    MainTitle,
    MainDownload,
    LearnMore,
} from './PlotlyContainerStyles';
import { sidePanelSlice } from 'Redux/sidePanelSlice';
import { SideModal } from 'components';

export const PlotlyContainer = ({
    title,
    sideModalTitle,
    refProp,
    localization,
}: IPlotlyContainer) => {
    const { handleClickTakeScreenShot } = useScreenshot();
    const [isLearnMoreShown, setIsLearnMoreShown] = useState(false);
    const {
        [localization]: {
            ['tabs']: {
                [title]: { selectionState, data, isHareLoading, legendPosition },
            },
        },
    } = useSelector(projectionSlice);

    const {
        [localization]: { isTortoiseLoading, isTortoiseLoaded },
    } = useSelector(sidePanelSlice);

    const handleLearnMore = () => {
        setIsLearnMoreShown((prev) => !prev);
    };

    const loadingStatus =
        (isTortoiseLoaded && isTortoiseLoading) || (isTortoiseLoaded && isHareLoading);

    return (
        <Main data-testid="PROJECTION.PLOTLY.CONTAINER.MAIN">
            <SidePanel title={title} localization={localization} />
            <MainWrapper data-testid={TestIds.projection.plotlyContainer.main}>
                <MainHeader>
                    <MainTitle>
                        <WppTypography
                            type="l-strong"
                            data-testid={TestIds.projection.plotlyContainer.title}
                        >
                            {title}
                        </WppTypography>
                        <LearnMore
                            type="xs-body"
                            id="learn-more"
                            onClick={handleLearnMore}
                            data-testid={TestIds.projection.actions.learnMoreButton}
                            isLearnMoreShown={legendPosition === 'top'}
                        >
                            Learn more
                        </LearnMore>
                    </MainTitle>
                    <MainDownload
                        id="download-icon"
                        onClick={() =>
                            handleClickTakeScreenShot(
                                refProp,
                                ['createScenarioButton', 'tabsSection'],
                                title,
                            )
                        }
                        data-testid={TestIds.projection.actions.downloadButton}
                    />
                </MainHeader>
                <PlotlyFromApi
                    title={title}
                    localization={localization}
                    sideModalTitle={sideModalTitle}
                    legendPosition={legendPosition}
                    isLoading={loadingStatus}
                    selectionState={selectionState}
                    isLegendsListShown={true}
                    data={data}
                />
            </MainWrapper>
            <SideModal
                isSidebarShown={isLearnMoreShown}
                title={capitalizeFirstLetter(sideModalTitle)}
                setIsSidebarShown={setIsLearnMoreShown}
                localization={localization}
            />
        </Main>
    );
};
